import { Node, Element } from 'slate';
import { NESTED_LIST_PATH_INDEX } from "../constants.js";

/**
 * Returns "list" node nested in "list-item" at a given path.
 * Returns null if there is no nested "list".
 */
export function getNestedList(editor, path) {
  var nestedListPath = [...path, NESTED_LIST_PATH_INDEX];

  if (!Node.has(editor, nestedListPath)) {
    return null;
  }

  var nestedList = Node.get(editor, nestedListPath);

  if (Element.isElement(nestedList) && editor.isListNode(nestedList)) {
    // Sanity check.
    return [nestedList, nestedListPath];
  }

  return null;
}